import React, { useState } from "react";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { deletePartner, updatePartner } from "../../../redux/CustomerReducer";
import { verifyAmbassador } from "../../../redux/CustomerReducer";

export default function InvestorsVerifiedData(props) {
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [updateIndex, setUpdateIndex] = useState(null);
  const [updateData, setUpdateData] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const dispatch = useDispatch();

  const deleteIconClicked = (index) => {
    let f=index.fullName;
    console.log(index);
    setDeleteIndex(index);
    Swal.fire({
      title: 'Are you sure to delete '+f+"?",
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        let id = props.driverData[index]._id;
        dispatch(deletePartner({ id, xy: props.driverData }));
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });
  };

  const updateClicked = (data, index) => {
    setUpdateData(data);
    setUpdateIndex(index);
    setIsUpdateModalOpen(true);
  };

  const closeUpdateModal = () => {
    setIsUpdateModalOpen(false);
  };

  const handleUpdate = () => {
    dispatch(updatePartner(updateData)); // Assuming updatePartner action is defined in your Redux slice
    setIsUpdateModalOpen(false);
    Swal.fire('Updated!', 'Your data has been updated.', 'success');
  };

  let filtered = props.driverData?.filter((item) => item.verified === true && item.verifieduser === true && item.category === "investor");

  return (
    <div>
      <table className="admin-table">
        <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              Title
            </th>
            <th>
              Email
            </th>
            <th>
              Location
            </th>
            <th>
              Twitter
            </th>
            <th>
              LinkedIn
            </th>
            <th>
              Phone
            </th>
          </tr>
        </thead>
        <tbody>
          {filtered?.map((row, index) => (
            <tr key={row?.fullName}>
              <td className="admin-table-strong">
                {row?.fullName}
              </td>
              <td>
                <div>{row?.title}</div>
              </td>
              <td>
                {row?.email}
              </td>
              <td>
                {row?.location}
              </td>
              <td>
                <a href={row?.twitter} className="admin-table-link" target="_blank" rel="noopener noreferrer">
                  Link here
                </a>
              </td>
              <td>
                <a href={row?.linkedIn} className="admin-table-link" target="_blank" rel="noopener noreferrer">
                  Link here
                </a>
              </td>
              <td>
                {row?.phone}
              </td>
              
            </tr>
          ))}
        </tbody>
      </table>

      {isUpdateModalOpen && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                      Update Data
                    </h3>
                    <div className="mt-2">
                      {/* Your input fields for updating data */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button onClick={handleUpdate} className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm">
                  Update
                </button>
                <button onClick={closeUpdateModal} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
